import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import { FormSelect } from '@components/Common/AwpFormInputs';

import { propTypes } from 'react-bootstrap/esm/Image';

const ListPreferences = ({ programs, areas, events, formikProps, dto }) => {
  const [areaList, setAreaList] = useState(areas);

  useEffect(() => {
    if (dto?.programs) {
      setAreaList(getAreaList(dto.programs));
    }
  }, [dto]);

  const getAreaList = (selectedPrograms) => {
    const programIds = selectedPrograms?.map((x) => x.value);

    if (programIds && programIds.length !== 0) {
      const filtered = areas
        .filter((a) => programIds.includes(a.parentId))
        .sort((a, b) => a.lastUpdated - b.lastUpdated);
      return filtered;
    }

    return areas;
  };

  const programsOnChange = (selectedPrograms, setFieldValue) => {
    const areaList = getAreaList(selectedPrograms);
    setAreaList(areaList);
    const programIds = selectedPrograms?.map((x) => x.value);
    const selectedAreas =
      programIds.length === 0 ? [] : formikProps.values?.list?.areas?.filter((x) => programIds.includes(x.parentId));

    setFieldValue('list.areas', selectedAreas ?? [], false);
  };

  const handleReset = (formikProps) => {
    formikProps.setFieldValue('list.programs', [], false);
    formikProps.setFieldValue('list.areas', [], false);
    formikProps.setFieldValue('list.events', [], false);
    setAreaList(areas);
  };

  return (
    <>
      <Card border="light" className="page-card">
        <Card.Header as="h3" style={{ backgroundColor: 'transparent' }}>
          EVENTS & PROCESSED LIST
        </Card.Header>
        <Card.Body>
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="list.programs"
            id="list.programs"
            label="Program"
            postChange={(e) => {
              programsOnChange(e, formikProps.setFieldValue);
            }}
            options={programs}
            isMulti={true}
          />
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="list.areas"
            id="list.areas"
            label="Avalanche Area"
            postChange={(e) => {}}
            options={areaList}
            isMulti={true}
          />
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="list.events"
            id="list.events"
            label="Event"
            postChange={(e) => {}}
            options={events}
            isMulti={true}
          />
          <Button className="my-3" variant="outline-primary" onClick={() => handleReset(formikProps)}>
            Reset
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

ListPreferences.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  eventTypes: PropTypes.arrayOf(PropTypes.object),
  formikProps: PropTypes.object,
  dto: PropTypes.object,
};

export default ListPreferences;
